import { FC, useContext } from 'react';
import styles from './logo.module.scss';
import { Button } from '@mui/material';
import { ProjectContext } from '../../../contexts/projectContext';
import helperService from '../../../services/helper.service';
import { WSkeleton } from 'components/wrappers/wrapper';

interface LogoProps {
  className?: string;
}
const Logo: FC<LogoProps> = ({ className }) => {
  const { projectData } = useContext(ProjectContext);

  const title = projectData?.title;
  const logo = projectData?.project_logo;

  const handleLogoClick = () => {
    window.location.href = '/home';
  };

  const classes = `
  ${styles.logo} 
  ${className || ''}`.trim();

  return (
    <div className={classes}>
      <Button className={styles['logo-button']} onClick={handleLogoClick}>
        {logo ? (
          <img src={logo} alt={'logo'} />
        ) : (
          <WSkeleton variant="rounded" height={40} width={150}></WSkeleton>
        )}
      </Button>
    </div>
  );
};

export default Logo;
